import { NavigateFunction, NavigateOptions, To, useLocation, useNavigate } from "react-router-dom";
import { APPS } from "../constants/AppsConstants.ts";
import RouterConstants from "../constants/RouterConstants.ts";
import { IframePages, IframePostMessageTypes, iframeRoutes } from "../models/new-iframe.ts";
import iframeStore from "../pages/IframeNew/iframe-store.tsx";

function useSecureNavigate() {
	const navigate = useNavigate();
	const location = useLocation();

	const fireIframeNavigatePostMessage = () => {
		if (iframeStore.isIframe()) {
			iframeStore.sendPostMessage(IframePostMessageTypes.Navigate, {
				to: iframeStore.getIframeAppName(iframeStore.iframe.config.landing_page as IframePages),
			});
		}
	};

	const navigateSecurely: NavigateFunction = (to: To | number, options?: NavigateOptions) => {
		if (iframeStore.isIframe()) {
			options = { replace: true, ...options };
		}
		if (typeof to === "number") {
			navigate(to);
		} else {
			const relativeUrlRegex = /^\/?(?:[^/]+\/?)+$/;
			const toPath = typeof to === "string" ? to : to.pathname;

			const extendedOptions = {
				...options,
				state: {
					...options?.state,
					from: location.pathname,
				},
			};

			if (toPath && relativeUrlRegex.test(toPath)) {
				fireIframeNavigatePostMessage();
				navigate(to, extendedOptions);
			} else {
				fireIframeNavigatePostMessage();
				navigate(
					iframeStore.isIframe()
						? (iframeRoutes[iframeStore.iframe.config.landing_page] ??
								iframeRoutes[APPS.TEXT_TO_IMAGE] ??
								"")
						: RouterConstants.CONSOLE.fullPath,
					extendedOptions,
				);
			}
		}
	};

	return navigateSecurely as NavigateFunction;
}

export default useSecureNavigate;
